import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'p', 'br',
  'strong', 'b', 'em', 'i', 'u', 's', 'strike', 'del',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'ul', 'ol', 'li',
  'blockquote',
  'code', 'pre',
  'hr',
];

/** Sanitize rich-text HTML before rendering with dangerouslySetInnerHTML. */
export const sanitizeRichTextHtml = (html: string): string =>
  DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR: [] });

const EMPTY_RICH_TEXT_PATTERN = /^<p>(?:<br\s*\/?>)?<\/p>$/i;

/** Normalize TipTap/HTML variants for stable comparisons and empty-state handling. */
export const normalizeRichTextHtml = (html: string): string => {
  const trimmed = (html || '').trim();
  if (!trimmed || EMPTY_RICH_TEXT_PATTERN.test(trimmed)) {
    return '';
  }

  return trimmed;
};

export const isEquivalentRichTextHtml = (left: string, right: string): boolean =>
  normalizeRichTextHtml(left) === normalizeRichTextHtml(right);

/** Plain-text preview for list rows and summaries (strips tags, collapses whitespace). */
export const stripRichTextToPlainText = (html: string): string => {
  const normalized = normalizeRichTextHtml(html);
  if (!normalized) return '';

  return normalized
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<\/p>\s*<p>/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};
